module.exports = __webpack_public_path__ + "9c8c9b8cb1c059b79fbd5677e2a34683.svg";